/**
 * The dimensions of a chip in the detail-page header's meta row: a 22px pill
 * with a 12px label and a delete icon scaled to match.
 *
 * Shared so a chip rendered INTO that row through `DetailPageHeaderMeta.element`
 * (a job tag) is sized by the same values as the row's own chips, rather than
 * by a copy of them that drifts.
 */
export const detailPageChipSx = {
  height: 22,
  borderRadius: 999,
  '& .MuiChip-label': { px: 1, fontSize: '0.75rem' },
  // Scaled to the 22px chip — the stock delete icon is built for a
  // full-height chip and swamps this one.
  '& .MuiChip-deleteIcon': {
    fontSize: 14,
    ml: '-2px',
    mr: '4px',
    color: 'text.disabled',
    '&:hover': { color: 'text.secondary' },
  },
} as const;
